export class VendorFormData {
  constructor(name = "", phone_number = "", company_store_name = "", message = "") {
    this.name = name;
    this.phone_number = phone_number;
    this.company_store_name = company_store_name;
    this.message = message;
  }
}

export class VendorResponse {
  constructor(status = false, data = null) {
    this.status = status;
    this.data = data;
  }
}